const dropDownPortalTargetName = "dropdowns";
const dropDownPortalTarget = document.getElementById(dropDownPortalTargetName);
export { dropDownPortalTarget, dropDownPortalTargetName };
